module.exports = __webpack_public_path__ + "img/51.1994b788.webp";